












































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import DepositAmountDialogComponent from '@/components/DepositAmountDialogComponent.vue'
import { Invoice, MailQueue, DepositAmount } from '@/domain/Invoice'
import { SendMail } from '@/domain/SendMail'
import { WindowPosition } from '@/domain/WindowPosition'
import InvoicesService, { SerchConditon } from '@/service/InvoicesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
    DepositAmountDialogComponent,
  },
})
export default class MemberInvoiceList extends Mixins(GlobalMixin) {
  invoicesService = InvoicesService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "請求日", value: "invoiceOn", width: "100px" },
          { text: "請求番号", value: "invoiceNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体識別記号", value: "specimenIds", width: "130px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "小計", value: "sumInfo.amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "sumInfo.tax", align: "end", filterable: false, width: "100px" },
          { text: "請求金額", value: "sumInfo.totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "報告書送付", value: "reportSend", align: "center", filterable: false, width: "120px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "メール", value: "mailSendAt", align: "center", filterable: false, width: "100px" },
          { text: "入金日", value: "paymentInfo.paymentOn", width: "100px" },
          { text: "入金金額", value: "paymentInfo.depositAmount", align: "end", filterable: false, width: "100px" },
          { text: "他文書", value: "links", filterable: false, sortable: false, width: "80px"  },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "200px" },
  ]
  list: Invoice[] = []
  selectItems: Invoice[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""
  mailSendInvoiceNos: string[] = []
  sendMail = new SendMail()
  isViewReportFileSendMode = false

  /* 入金ダイアログ */
  depositAmountDialog = false
  paymenAmount = 0
  isPaymentInInstallments = false
  depositAmountInvoiceNos: string[] = []

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    return this.selectItems.length > 0
  }

  /**
   * メールボタンの無効
   */
  get disableMail() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}:${x.invoiceToInfo.invoiceToName}`)
    const distinct = [...new Set(keys)]
    return distinct.length !== 1
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.invoice.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.invoice.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.invoice.list.conditions", JSON.stringify(this.conditions))
    this.invoicesService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.mountedDataTable("tool.invoice.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Invoice): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Invoice) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.invoiceNo) {
      this.$router.push(`/member/invoice/edit/${event.invoiceNo}`)
    }
    this.rowItemKey = event.invoiceNo
    this.rowItemClickTime = now
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint(invoiceNo: string) {
    this.invoicesService.print(invoiceNo)
      .then(dto => {
        this.list.filter(x => x.invoiceNo === invoiceNo)
            .forEach(x => x.printAt = dto.printAt)
        this.openPdfViewDialog("請求書印刷", dto.invoiceFile.content)
      })
  }

  /**
   * メール一括送信ボタンのクリック
   */
  onMail() {
    const invoiceNos = this.selectItems.map(x => x.invoiceNo)
    this.onSendMail(invoiceNos)
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail(invoiceNos: string[]) {
    this.mailSendInvoiceNos = invoiceNos
    // eslint-disable-next-line
    const invoiceNo = invoiceNos.find(x => true)
    const invoice = this.list.find(x => x.invoiceNo === invoiceNo)
    this.isViewReportFileSendMode = invoice === undefined ? false : invoice.hasAgency || invoice.customerInfo.billingRule !== 2
    this.invoicesService.generateMailTemplate(this.mailSendInvoiceNos)
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, invoiceNos: this.mailSendInvoiceNos, reportFileSendMode: event.reportFileSendMode, reportNos: event.reportNos})
    this.invoicesService.mailQueuePush(mailQueue)
      .then((x) => {
          this.list.filter(y => mailQueue.invoiceNos.indexOf(y.invoiceNo) >= 0)
            .forEach(y => y.mailSendAt = x.mailSendAt)
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 入金一括送信ボタンのクリック
   */
  onDeposit() {
    const invoiceNos = this.selectItems.map(x => x.invoiceNo)
    const paymenAmount = this.selectItems
        .map(x => (x.sumInfo.amount + x.sumInfo.tax))
        .reduce((p, x) => p + x, 0)
    this.onDepositAmount(invoiceNos, paymenAmount, false)
  }

  /**
   * 入金ボタンのクリック
   */
  onDepositAmount(invoiceNos: string[], paymenAmount: number, isPaymentInInstallments: boolean) {
    this.depositAmountInvoiceNos = invoiceNos
    this.paymenAmount = paymenAmount
    this.isPaymentInInstallments = isPaymentInInstallments
    this.depositAmountDialog = true
  }

  /**
   * 入金金額入力
   */
  onDepositAmounted(event: [number, string]) {
    const [amount, paymentOn] = event
    this.showLoading()
    const invoiceNos = this.depositAmountInvoiceNos
    const invoices = this.list.filter(x => invoiceNos.indexOf(x.invoiceNo) >= 0)
    const isIndividual = invoices.length === 1
    const depositAmounts = invoices.map((x) => 
      isIndividual ? new DepositAmount({paymentOn: paymentOn, invoiceNo: x.invoiceNo, depositAmount: amount}) : new DepositAmount({paymentOn: paymentOn, invoiceNo: x.invoiceNo, depositAmount: (x.sumInfo.amount + x.sumInfo.tax)})
    )
    this.invoicesService.depositAmount(depositAmounts)
      .then(() => {
          if (isIndividual) {
            /* 個別入金 */
            invoices.forEach(x => {
              x.paymentInfo.depositAmount = amount
              x.paymentInfo.paymentOn = paymentOn
            })
          } else {
            /* 一括入金 */
            invoices.forEach(x => {
              x.paymentInfo.depositAmount = (x.sumInfo.amount + x.sumInfo.tax)
              x.paymentInfo.paymentOn = paymentOn
            })
          }
          this.alert("入金金額を更新しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("入金金額の更新に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }
  
  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.invoice.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.invoice.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.invoice.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
